/* eslint-disable no-undef */

/**
 * Add the script to the page. This should be able to be in Chatbot/Mavenoid.php but that is failing to init the mavenoid object before the inits need them, hopefully 6.3 changes fix this
 *
 * https://make.wordpress.org/core/2023/07/14/registering-scripts-with-async-and-defer-attributes-in-wordpress-6-3/
 *
 */

export const addMavenoidScript = () => {
	// --- begin mavenoid embedded troubleshooter ---
	( function ( m, a, v, e, n, o, i, d ) {
		d = m.createElement( e );
		d.async = true;
		d.src = 'https://app.mavenoid.com' + v;
		i = m.getElementsByTagName( e )[ 0 ];
		i.parentNode.insertBefore( d, i );
		n[ o ] = n[ o ] || [];
	} )( document, 0, '/embedded/embedded.js', 'script', window, 'mavenoid' );
	// --- end mavenoid embedded troubleshooter ---
};

/**
 * Show the chat-bot on external button click event.
 *
 */
export const chatbotShow = () => {
	const buttons = document.querySelectorAll( '.chatbot-show' );
	if ( ! buttons ) return;
	if ( ! mavenoid ) return;
	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			mavenoid.push( {
				event: 'troubleshooter-show',
			} );
		} );
	} );
};

export const chatbotDesktop = () => {
	if ( ! mavenoid || ! window.mavenoidConfig ) return;

	const { clientId, event, orgName, productId } = window.mavenoidConfig;

	mavenoid.config = {
		noIframe: false,
		clientId,
	};

	mavenoid.push( {
		event,
		productId,
		orgName,
	} );
};

export const chatbotMobile = () => {
	if ( ! mavenoid || ! window.mavenoidConfig ) return;

	const { clientId, event, orgName, productId } = window.mavenoidConfig;

	mavenoid.config = {
		noIframe: false,
		clientId,
	};
	mavenoid.push( {
		event,
		orgName,
		productId,
		isInAppWebView: true,
	} );
};
/* eslint-enable no-undef */
